// Language-agnostic 3D anchors per body-area slug, in figure space (metres, feet at y=0, +z = front).
// Used by the 3D body (Body3D) and projected for the 2.5D fallback (BodyFlat).
export const anchors = {
  huvud: { pos: [0, 1.72, 0.1], normal: [0, 0.15, 1] },
  nacke: { pos: [0, 1.535, 0.05], normal: [0, 0.1, 1] },
  axel: { pos: [-0.215, 1.455, 0.03], normal: [-0.6, 0.45, 0.65] },
  armbage: { pos: [0.265, 1.14, 0.04], normal: [0.3, 0, 0.95] },
  hand: { pos: [-0.33, 0.8, 0.03], normal: [0, 0, 1] },
  rygg: { pos: [0, 1.2, -0.09], normal: [0, 0, -1] },
  backen: { pos: [0, 1.0, 0.1], normal: [0, 0, 1] },
  hoft: { pos: [0.19, 0.92, 0.02], normal: [0.9, 0, 0.45] },
  kna: { pos: [-0.1, 0.52, 0.068], normal: [0, 0, 1] },
  vad: { pos: [0.1, 0.33, -0.058], normal: [0, 0, -1] },
  fot: { pos: [0.1, 0.075, 0.07], normal: [0, 0.7, 0.7] },
  ta: { pos: [-0.1, 0.05, 0.165], normal: [0, 0.4, 1] },
};

// Areas shown on the back view of the 2.5D fallback (x mirrored).
export const backViewAreas = ["nacke", "axel", "rygg", "backen", "hoft", "vad"];
